import { gsap } from 'gsap';
import { cart } from '@mockly/cart';

const selectors = {
  removeButton: '[data-remove-button]',
}

class ComponentCartLine extends HTMLElement {
  constructor() {
    super();

    this.removeLine = this.removeLine.bind(this);
  }

  setupEventListeners() {
    this.removeButton?.addEventListener('click', this.removeLine);
  }

  removeEventListeners() {
    this.removeButton?.removeEventListener('click', this.removeLine);
  }

  removeLine() {
    gsap.to(this.cartLine, {
      height: 0,
      opacity: 0,
      duration: 0.45,
      ease: 'expo.out',
      onComplete: async () => {
        await cart.remove(this.id);
        this.cartLine.remove();
      }
    })
  }

  connectedCallback() {
    this.id = this.dataset.id;
    this.cartLine = this;
    
    this.removeButton = this.querySelector(selectors.removeButton);

    this.setupEventListeners();
  }

  disconnectedCallback() {
    this.removeEventListeners();
  }
}

export { ComponentCartLine };

if (!customElements.get('cart-line')) {
  customElements.define('cart-line', ComponentCartLine);
}